/**
 * # Multicolumn Component
 * - Markup: snippets/multicolumn.liquid
 * - CSS: assets/section-multicolumn.css
 */
if (!customElements.get("multicolumn-component")) {
  class MulticolumnElement extends HTMLElement {
    constructor() {
      super();
    }

    /**
     * Called when the element is attached to the DOM.
     * Initializes event listeners and properties.
     */
    connectedCallback() {
      this.activeVideo = null;
      this.addEventListener("click", this.eventDispatcher.bind(this));
    }

    /**
     * Called when the element is detached from the DOM.
     * Removes event listeners.
     */
    disconnectedCallback() {
      this.removeEventListener("click", this.eventDispatcher.bind(this), true);
      this.activeVideo?.removeEventListener(
        "click",
        this.activeVideoEventDispatcher.bind(this),
        true
      );
    }

    /**
     * Event handler for click events on the element.
     * Finds the associated video and triggers its display.
     * @param {Event} event - The click event.
     */
    eventDispatcher(event) {
      const cardContent = event.target.closest(
        ".multicolumn-card__image-wrapper"
      );
      if (cardContent) {
        const { videoHandle } = cardContent.dataset;
        this.videoFinder(videoHandle);
        return;
      }
    }

    /**
     * Finds and displays the video associated with a given video handle.
     * @param {string} videoHandle - The video handle to identify the video.
     */
    videoFinder(videoHandle) {
      const videoContainer = this.querySelector(
        `.multicolumn-popup-video[data-video-handle="${videoHandle}"]`
      );
      if (!videoContainer) return;
      this.activeVideo = videoContainer;

      this.activeVideo.addEventListener(
        "click",
        this.activeVideoEventDispatcher.bind(this)
      );

      videoContainer.dataset.showMulticolumnVideo = true;
    }

    /**
     * Event handler for click events on the active video.
     * Closes the video if the close button or overlay is clicked.
     * @param {Event} event - The click event.
     */
    activeVideoEventDispatcher(event) {
      const closeBtn = event.target.closest(".close-multicolumn-popup-video");
      const overlay = event.target.closest(".multicolumn-popup-video-overlay");

      if (closeBtn || overlay) {
        this.closeVideo();
        return;
      }
    }

    /**
     * Closes the active video by updating the dataset and resetting the iframe source.
     */
    closeVideo() {
      this.activeVideo.dataset.showMulticolumnVideo = false;
      const iframe = this.activeVideo.querySelector("iframe");
      iframe.src = iframe.src;
    }
  }
  customElements.define("multicolumn-component", MulticolumnElement);
}
